module.exports = __webpack_public_path__ + "assets/img/60328fbd230f72b022bf04ab8676ba81.png";